import * as React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SxProps, Theme,Typography,MenuItem ,FormControl,SelectChangeEvent,Select} from "@mui/material";
type props = {
  placeholder: string;
  iconStyle:SxProps<Theme> | undefined,
  handleChange: (event: SelectChangeEvent) => void;
  value: string;
  data:{label:string,value:string}[]
};
export default function SelectAutoWidth({ placeholder ,iconStyle,value="",handleChange,data}: Partial<props>) {

const truncateValue = (value: string) =>
    value.length > 5 ? value.slice(0, 5) + "…" : value;

  return (
    <FormControl fullWidth >
      <Select
        id="demo-simple-select-autowidth"
        value={value} 
        onChange={handleChange}
        displayEmpty
        
        inputProps={{ MenuProps: { disableScrollLock: true }, }}
        IconComponent={(props) => (
          <ExpandMoreIcon
        {...props}
        sx={iconStyle}
          />
        )}
          renderValue={(selected) => {
          if (selected === "") {
            return <Typography>{placeholder || "Select Location"}</Typography>;
          }
          return truncateValue(selected as string);
        }}
        variant="standard"
        sx={{
          border: "none",
          "&::before, &::after": { border: "none !important" },
          "& .MuiSelect-select": {
           paddingRight: "24px",
           overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
          },
          fontSize: "15px",
          
        }}
      >
        <MenuItem value="" >
          {placeholder || "Select Location"}
        </MenuItem>
        {data?.map((item, index) => (
          <MenuItem key={index} value={item.value}>
            {item.label}
          </MenuItem>
        ))}

      </Select>
    </FormControl>
  );
}
